import React, { useState, useEffect } from 'react';
import './TimestampConverter.css';

function TimestampConverter() {
  const [timestamp, setTimestamp] = useState('');
  const [convertedTime, setConvertedTime] = useState('');
  const [currentTimestamp, setCurrentTimestamp] = useState({
    seconds: Math.floor(Date.now() / 1000),
    milliseconds: Date.now()
  });
  const [conversionHistory, setConversionHistory] = useState([]);
  const [toast, setToast] = useState({ show: false, message: '' });

  // 更新当前时间戳
  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      setCurrentTimestamp({
        seconds: Math.floor(now / 1000),
        milliseconds: now
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  const convertTimestamp = (timestamp) => {
    let date;
    if (timestamp.length === 10) {
      // 10位时间戳，按秒处理
      date = new Date(Number(timestamp) * 1000);
    } else if (timestamp.length === 13) {
      // 13位时间戳，按毫秒处理
      date = new Date(Number(timestamp));
    } else {
      throw new Error("无效的时间戳");
    }
    
    // 格式化为 yyyy-MM-dd HH:mm:ss
    const options = { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit', 
      hour12: false 
    };
    return date.toLocaleString('sv-SE', options).replace(' ', 'T').replace('T', ' ').replace(',', '');
  };

  const handleConvert = () => {
    try {
      const result = convertTimestamp(timestamp);
      setConvertedTime(result);
      
      // 添加到历史记录
      if (timestamp.trim()) {
        setConversionHistory(prev => {
          const newHistory = [{ 
            timestamp: timestamp, 
            convertedTime: result,
            timestamp_type: timestamp.length === 10 ? "秒级" : "毫秒级"
          }, ...prev];
          // 只保留最近的10条记录
          return newHistory.slice(0, 5);
        });
      }
    } catch (error) {
      setConvertedTime(error.message);
    }
  };

  const showToast = (message) => {
    setToast({ show: true, message });
    
    // 1秒后自动隐藏
    setTimeout(() => {
      setToast({ show: false, message: '' });
    }, 1000);
  };

  const handleCopyText = (text) => {
    navigator.clipboard.writeText(text.toString())
      .then(() => {
        showToast(text + ' 已复制到剪贴板');
      })
      .catch(err => {
        console.error('复制失败:', err);
      });
  };

  const handleClearHistory = () => {
    setConversionHistory([]);
  };

  return (
    <div className="timestamp-converter">
      {toast.show && (
        <div className="toast-message">
          {toast.message}
        </div>
      )}
      
      <h2>时间戳转换工具</h2>
      
      <div className="timestamp-container">
        <div className="timestamp-left-section">
          <div className="current-timestamp">
            <h3>当前时间戳</h3>
            <div className="timestamp-display">
              <div className="timestamp-item">
                <span>秒级时间戳 (10位):</span>
                <div className="timestamp-value">
                  <span>{currentTimestamp.seconds}</span>
                  <button onClick={() => handleCopyText(currentTimestamp.seconds)}>复制</button>
                </div>
              </div>
              <div className="timestamp-item">
                <span>毫秒级时间戳 (13位):</span>
                <div className="timestamp-value">
                  <span>{currentTimestamp.milliseconds}</span>
                  <button onClick={() => handleCopyText(currentTimestamp.milliseconds)}>复制</button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="converter-section">
            <h3>时间戳转换</h3>
            <div className="input-group">
              <input 
                type="text" 
                value={timestamp} 
                onChange={(e) => setTimestamp(e.target.value)} 
                placeholder="输入10位或13位时间戳" 
              />
              <button onClick={handleConvert}>转换</button>
            </div>
            
            {convertedTime && (
              <div className="result">
                <h4>转换结果:</h4>
                <div className="result-display">
                  <div className="result-value">{convertedTime}</div>
                  <button onClick={() => handleCopyText(convertedTime)}>复制</button>
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className="history-section">
          <div className="history-header">
            <h3>转换历史</h3>
            {conversionHistory.length > 0 && (
              <button onClick={handleClearHistory} className="clear-btn">清除</button>
            )}
          </div>
          
          {conversionHistory.length > 0 ? (
            <ul className="history-list">
              {conversionHistory.map((item, index) => (
                <li key={index} className="history-item">
                  <div className="history-timestamp">
                    <div className="timestamp-content">
                      <strong>{item.timestamp_type}时间戳:</strong> {item.timestamp}
                    </div>
                    <button 
                      onClick={() => handleCopyText(item.timestamp)} 
                      className="history-copy-btn"
                      title="复制时间戳"
                    >
                      复制
                    </button>
                  </div>
                  <div className="history-converted">
                    <div className="converted-content">
                      <strong>转换结果:</strong> {item.convertedTime}
                    </div>
                    <button 
                      onClick={() => handleCopyText(item.convertedTime)} 
                      className="history-copy-btn"
                      title="复制转换结果"
                    >
                      复制
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="empty-history">
              <p>暂无转换历史</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TimestampConverter; 